import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import Theme from 'components/template/Theme'
import Layout from 'components/layout'
import history from './history'
import './locales'
import { MsalProvider } from '@azure/msal-react'
import msalInstance, { initializeMsal } from 'services/AzureAuthService'

function App() {
    useEffect(() => {
        initializeMsal()
    }, [])
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <MsalProvider instance={msalInstance}>
                    <BrowserRouter history={history}>
                        <Theme>
                            <Layout />
                        </Theme>
                    </BrowserRouter>
                </MsalProvider>
            </PersistGate>
        </Provider>
    )
}

export default App
